<template>
	<span>
		<template v-if="field.type === 'file' && value.value && value.value.url">
			<v-btn text @click.stop.native="imgDialog = true" max-width="100%" height="33px" class="truncate-sub-text">
				{{ getValue(field, value) }}
			</v-btn>
			<v-dialog v-model="imgDialog" width="500">
				<v-card>
					<v-img v-if="value.value" :src="value.value.url"></v-img>
				</v-card>
			</v-dialog>
		</template>
		<template v-else>
			{{ getValue(field, value) }}
		</template>
	</span>
</template>
<script>
	import fielvalue from '../../mixins/fieldvalue';

    export default {
		mixins: [fielvalue],
		data() {
			return {
				imgDialog: false
			}
		},
        props: [
            'field',
			'value',
			'format'
        ]
    }
</script>
